export default __webpack_public_path__ + "static/media/gonzales.37b80918.jpeg";